import { megasToOctets } from '@common/utils/file';

export const SIZE_10MO_OCTETS = megasToOctets(10);
export const SIZE_4MO_OCTETS = megasToOctets(4);
